import React from 'react'

const UserKYC = () => {
  return (
    <div className='w-full h-[calc(90vh-2.4rem)] bg-white rounded-xl shadow-lg flex flex-col items-center justify-center'>
      These is UserKYC Page
    </div>
  )
}

export default UserKYC
